import React from 'react';

import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';
import { formatDayToMonth } from 'utils/date/format.util';

import TableClientList from 'clientCommunications/components/Campaigns/TableClientList';

const AutoMsgDetails = ({ message, showContent, sortFunction }) => {
  const { t } = useTranslation();

  return (
    <div key={message.id}>
      <div className={`bucket-message ${message.isCollapsed ? 'opened' : ''}`}>
        {message.isCollapsed ? (
          <button onClick={() => showContent(message.id, false)} className="btn btn-violet btn-sm">
            {t('campaigns.tableRows.hideDetailsBtn')}
          </button>
        ) : (
          <button className="btn btn-violet btn-sm" key={message.id} onClick={() => showContent(message.id, true)}>
            {t('campaigns.tableRows.viewRecipientsBtn')}
          </button>
        )}
        <span className="purple">
          {t('campaigns.tableRows.sentOn')} {formatDayToMonth(message.timestamp)}
          {S.space}
        </span>
        <span>{message.text}</span>
        {message.clients && <TableClientList campaignId={message.id} clients={message.clients} wholeList sortFunction={sortFunction} />}
      </div>
    </div>
  );
};

export default AutoMsgDetails;
